import { useEffect, useRef, useState, useCallback } from 'react';
import { API_URL } from '../api';
import { chatMediaUrl, freshChatAttachment } from '../utils/chatMedia';

export default function useChatMedia(attachment, chatId, messageId) {
  const original = chatMediaUrl(attachment?.url, API_URL);
  const [url, setUrl] = useState(original);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [version, setVersion] = useState(0);
  const attempted = useRef(false);
  const generation = useRef(0);
  useEffect(() => {
    generation.current += 1;
    attempted.current = false;
    setUrl(original); setError(''); setLoading(false);
    return () => { generation.current += 1; };
  }, [original, attachment?.id, chatId, messageId]);
  const retry = useCallback(async () => {
    const current = generation.current;
    attempted.current = true;
    setLoading(true); setError('');
    try {
      const fresh = await freshChatAttachment(attachment, chatId, messageId);
      if (current === generation.current) { setUrl(fresh.url); setVersion(value => value + 1); }
      return fresh;
    } catch (failure) {
      if (current === generation.current) setError(failure.message || 'Не удалось загрузить файл');
      return null;
    } finally { if (current === generation.current) setLoading(false); }
  }, [attachment, chatId, messageId]);
  const onError = () => {
    if (loading) return;
    if (!attempted.current && chatId && messageId && attachment?.id) retry();
    else setError('Не удалось загрузить файл. Повторите попытку или скачайте оригинал.');
  };
  return { url, error, loading, version, retry, onError };
}
